import React, { Component } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { connect } from 'redaction'
import actions from 'redux/actions'
import { mixpanel, snowplow, constants } from 'common/helpers'

import Modal from 'components/modal/Modal/Modal'
import WeMissedYouContent from 'components/WeMissedYouContent/WeMissedYouContent'

import messages from './messages'
import s from './WeMissedYouModal.scss'


class WeMissedYouModal extends Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    firstName: PropTypes.string,
    countOfClosings: PropTypes.number,
    hasLEPInQueueFirstMonth: PropTypes.bool,
    currentMonth: PropTypes.string,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    name: constants.modals.WeMissedYou,
    firstName: '',
    countOfClosings: 0,
    hasLEPInQueueFirstMonth: false,
  }

  componentDidMount() {
    snowplow.track(constants.snowplowEvents.cardUpdatePopup)
  }

  close = () => {
    const { name, onClose } = this.props

    actions.models.ui.setClosedPopup(constants.modals.WeMissedYou)
    actions.models.modals.close(name)

    if (typeof onClose === 'function') {
      onClose()
    }
  }

  render() {
    const { name, firstName, countOfClosings, hasLEPInQueueFirstMonth, currentMonth } = this.props

    return (
      <Modal
        className={s.weMissedYouModal}
        name={name}
        title={messages.title}
        onClose={this.close}
      >
        <WeMissedYouContent
          firstName={firstName}
          hasLEPInQueueFirstMonth={hasLEPInQueueFirstMonth}
          currentMonth={currentMonth}
          countOfClosings={countOfClosings}
          onClose={this.close}
        />
      </Modal>
    )
  }
}


export default connect({
  firstName: 'models.me.firstName',
  hasLEPInQueueFirstMonth: 'models.me.hasLimitedEditionProductInFirstMonth',
  countOfClosings: (state) => {
    const { models: { ui: { closedPopups: { [constants.modals.WeMissedYou]: modalInfo } } } } = state

    if (!modalInfo) {
      return 0
    }

    // TODO ask backend to make a consistent type of data in rest/popup
    return typeof modalInfo === 'number' ? modalInfo : modalInfo.count
  },
  currentMonth: () => {
    const monthIndex = new Date().getMonth()

    return moment.monthsShort(monthIndex)
  },
})(WeMissedYouModal)
